import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { FULL_API_BASE_URL } from "../../Config/Config";

// Thunk to handle adding/removing favorites
export const toggleFavorite = createAsyncThunk(
  "favorites/toggleFavorite",
  async (
    { userId, clientBrId, screen_id, isFavorite },
    { rejectWithValue }
  ) => {
    try {
      const operation = isFavorite ? "delete" : "create";
      const response = await axios.post(
        `${FULL_API_BASE_URL}/manage-user-favourite?operation=${operation}&user_id=${userId}&screen_id=${screen_id}&client_br_id=${clientBrId}`
      );
      console.log(response.data);

      return {
        screen_id,
        isFavorite: !isFavorite,
        ui_path: response.data.ui_path, // Adjust these properties based on actual response
        display_name: response.data.display_name, // Adjust these properties based on actual response
      };
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const favoritesSlice = createSlice({
  name: "favorites",
  initialState: {
    data: [], // Holds the list of favorite items
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(toggleFavorite.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(toggleFavorite.fulfilled, (state, action) => {
        state.loading = false;
        const { screen_id, isFavorite, ui_path, display_name } = action.payload;

        if (isFavorite) {
          // Add the favorite if not already in the list
          state.data.push({ screen_id, ui_path, display_name });
        } else {
          // Remove the favorite if it exists in the list
          state.data = state.data.filter((fav) => fav.screen_id !== screen_id);
        }
      })
      .addCase(toggleFavorite.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error toggling favorite";
      });
  },
});

export default favoritesSlice.reducer;
